import { useNavigate } from "react-router-dom";
import { homeData } from "../../../mocks/homeData";
import type { HomeProduct } from "../../../api";

interface Props {
  data?: { tag?: string; title?: string; items?: HomeProduct[] } | null;
}

export default function ProductsSection({ data: apiData }: Props) {
  const navigate = useNavigate();
  // apiData 可能返回空 items，此时回退到 mock 数据
  const products = (apiData && apiData.items && apiData.items.length > 0) ? apiData : homeData.products;

  return (
    <section className="bg-dark py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-12">
          <div className="flex items-start gap-4">
            <a
              href="/products"
              onClick={(e) => {
                e.preventDefault();
                navigate("/products");
              }}
              className="inline-flex items-center px-4 py-1.5 border border-white/30 text-white text-sm rounded-full hover:bg-white/10 transition-colors"
            >
              {products.tag}
            </a>
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight md:text-right md:max-w-xl">
            {products.title}
          </h2>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {products.items.map((product) => (
            <div
              key={product.id}
              onClick={() => navigate(`/products/${product.id}`)}
              className="group bg-white rounded-xl overflow-hidden cursor-pointer hover:shadow-lg transition-all duration-300"
              data-product-shop
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4">
                <h3 className="text-dark font-semibold text-base mb-1">
                  {product.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}